import { withNamespace } from "@/i18n/lazy-route"

/** Invoices and credit notes (LLD §9.11, Task 5.3), with the `invoices` namespace. */
export const InvoicesScreen = withNamespace("invoices", () => import("./screens/InvoicesScreen"), {
  en: () => import("@/i18n/locales/en/invoices.json"),
  fr: () => import("@/i18n/locales/fr/invoices.json"),
})
